import { render, staticRenderFns } from "./OrganizationUserList.vue?vue&type=template&id=37a3437f&scoped=true&"
import script from "./OrganizationUserList.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserList.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationUserList.vue?vue&type=style&index=0&id=37a3437f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3437f",
  null
  
)

export default component.exports